export default __webpack_public_path__ + "static/media/ntuc-health.9ae8bd99.svg";